// @noflow
import { isEmpty, isEqual, cloneDeep } from 'lodash';
import { CarouselGroupType } from './constants';

const defaultContent = {
  fetching: false,
  error: false,
  content: [],
};

const defaultList = {
  fetching: false,
  error: false,
  content: {
    count: 0,
    franchises: [],
    name: undefined,
    networks: [],
  },
};

const defaultList10ft = {
  fetching: false,
  error: false,
  content: {
    count: 0,
    item_type: '',
    items: [],
    items_available: 0,
    list_name: '',
    offset: 0,
    title: '',
  },
  sort: undefined,
};

export const initialState = {
  lists: {},
  groups: Object.values(CarouselGroupType).reduce(
    (obj, carousel) => ({
      ...obj,
      [carousel]: {
        ...defaultContent,
      },
    }),
    {},
  ),
};

const removeDvrItemsFromCarouselLists = (lists: Lists, ids: Array<string>) => {
  const carouselLists = cloneDeep(lists);
  Object.keys(carouselLists).forEach(listId => {
    const list = carouselLists[listId];
    if (
      list &&
      list.content &&
      list.content.item_type === 'recording' &&
      !isEmpty(list.content.items)
    ) {
      carouselLists[listId].content.items = list.content.items.filter(
        item => !ids.includes(item.recording_id),
      );
    }
  });
  return carouselLists;
};

const removeDvrItemsFromCarouselGroup = (group: CarouselGroup, ids: Array<string>) => {
  const carouselGroup = cloneDeep(group);
  Object.keys(carouselGroup.content).forEach(listId => {
    const list = carouselGroup.content[listId];
    if (list && list.item_type === 'recording' && !isEmpty(list.items)) {
      carouselGroup.content[listId].items = list.items.filter(
        item => !ids.includes(item.recording_id),
      );
    }
  });
  return carouselGroup;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_CAROUSEL_GROUP':
      return {
        ...state,
        groups: {
          ...state.groups,
          [action.groupType]: {
            ...(state.groups[action.groupType] || defaultContent),
            fetching: true,
            error: false,
          },
        },
      };

    case 'RECEIVE_CAROUSEL_GROUP':
      return {
        ...state,
        groups: {
          ...state.groups,
          [action.groupType]: {
            ...(state.groups[action.groupType] || defaultContent),
            content: action.payload,
            fetching: false,
            error: false,
          },
        },
      };

    case 'REQUEST_CAROUSEL_GROUP_ERROR':
      return {
        ...state,
        groups: {
          ...state.groups,
          [action.groupType]: {
            ...(state.groups[action.groupType] || defaultContent),
            fetching: false,
            error: action.error || 'Error fetching content.',
          },
        },
      };

    case 'RESET_CAROUSEL_GROUP':
      return {
        ...state,
        groups: {
          ...state.groups,
          [action.groupType]: {
            ...defaultContent,
          },
        },
      };

    case 'REQUEST_CAROUSEL_LIST_10FT':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.carouselName]: {
            ...(isEqual(state.lists[action.carouselName]?.sort, action.sort)
              ? state.lists[action.carouselName] || defaultList10ft
              : defaultList10ft),
            fetching: true,
            error: false,
          },
        },
      };

    case 'RECEIVE_CAROUSEL_LIST_10FT':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.carouselName]: {
            ...(state.lists[action.carouselName] || defaultList10ft),
            content: {
              ...action.payload,
              /* pagination: adding payload into existing items */
              items: [
                ...state.lists[action.carouselName]?.content?.items?.slice(0, action.offset),
                ...(action.payload?.items || []),
              ],
            },
            fetching: false,
            error: false,
            sort: action.sort,
          },
        },
      };

    case 'REQUEST_CAROUSEL_LIST_ERROR_10FT':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.carouselName]: {
            ...(state.lists[action.carouselName] || defaultList10ft),
            fetching: false,
            error: action.error || 'Error fetching contents',
          },
        },
      };

    case 'REQUEST_CAROUSEL_LIST':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.listName]: {
            ...(state.lists[action.listName] || defaultList),
            fetching: true,
            error: false,
          },
        },
      };

    case 'RECEIVE_CAROUSEL_LIST':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.listName]: {
            ...(state.lists[action.listName] || defaultList),
            content: action.payload,
            fetching: false,
            error: false,
          },
        },
      };

    case 'REQUEST_CAROUSEL_LIST_ERROR':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.listName]: {
            fetching: false,
            error: action.error || 'Error fetching contents',
          },
        },
      };

    case 'RESET_CAROUSEL_LIST':
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.listName]: {
            ...defaultList,
          },
        },
      };

    case 'ON_AUTH':
      return {
        ...initialState,
      };

    case 'REMOVE_DVRS_FROM_CAROUSELS':
      return {
        ...state,
        lists: removeDvrItemsFromCarouselLists(state.lists, action.ids),
        groups: {
          ...state.groups,
          home: removeDvrItemsFromCarouselGroup(state.groups.home, action.ids),
          dvr: removeDvrItemsFromCarouselGroup(state.groups.dvr, action.ids),
        },
      };

    case 'CHANGE_ACTIVE_RECEIVER_SUCCESS': {
      return {
        ...state,
        groups: {
          ...state.groups,
          dvr: { ...defaultContent },
          home: { ...defaultContent },
        },
        lists: {
          ...state.lists,
          recordings: undefined,
        },
      };
    }

    default:
      return state;
  }
};

export default reducer;
